exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".package-first-box-btn {padding: 0px !important}\n.pricingTable .btn-block{width: 42%;}\n.pricingTable-bg {\n    position: absolute;\n    background: rgba(0, 0, 0, .6);\n    height: 100%;\n    width: 100%;\n    }\n.pricingTable-bg-text {\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    }\n.pricingTable-bg-text p {\n    color: #fff;\n    font-weight: bold;\n    margin: 0;\n    text-transform: capitalize;\n    line-height: 22px;\n    font-size: 17px;\n    }\n    ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/packagedata/packagedata.component.css
// module id = ../../../../../src/app/home/packagedata/packagedata.component.css
// module chunks = common